/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
/**
 * The reason a user received a notification.
 */
export const NotificationReasons = /* #__PURE__ */ parsers.exactly('assignee', 'author', 'replied');
